import styled from 'styled-components';

export const StyledText = styled.p<{ size: 'xs' | 's' | 'm' | 'l' | 'xl' }>`
  color: var(--text-color-body-invert);
  margin: 0;
  font: ${(props) => {
    if (props.size === 'xs') return 'var(--text-body-xs)';
    if (props.size === 's') return 'var(--text-body-s)';
    if (props.size === 'l') return 'var(--text-body-l)';
    if (props.size === 'xl') return 'var(--text-body-xl)';
    return 'var(--text-body-m)';
  }};
  letter-spacing: 0.5px;
`;
